import { combineReducers } from 'redux';

import common from './reducers/common';

import updatePatientInsurance from './requests/update-patient-insurance';
import deletePatientInsurance from './requests/delete-patient-insurance';
import createPatientInsurance from './requests/create-patient-insurance';
import getPatientInsurancesList from './requests/get-patient-insurances-list';
import checkUploadedInsuranceCardOCR from './requests/check-uploaded-insurance-card-ocr';
import exportPatientInsuranceEhrDocuments from './requests/export-patient-insurance-ehr-documents';

export default combineReducers({
  common,

  checkUploadedInsuranceCardOCR,
  exportPatientInsuranceEhrDocuments,
  createPatientInsurance,
  deletePatientInsurance,
  getPatientInsurancesList,
  updatePatientInsurance,
});



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/index.js